import React from 'react'
import { useDocumentTitle } from '../utils/hooks'
import AddDataToSurvey from '../components/AddDataToSurvey'
import ToolPage from '../components/ToolPage'
import Menu from '../components/Menu'
import { useParams } from 'react-router-dom'

export default function AddDataToSurveyPage() {
  const { surveyId } = useParams()
  const pageName = 'Add Data to Survey'
  useDocumentTitle(pageName)
  return <ToolPage menu={<Menu pageName={pageName} />} tool={<AddDataToSurvey />} />
}